import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './News.css';
function New({ item }) {
    const imgSrc = item.pictureUrl ? (process.env.REACT_APP_API_BASE_URL + "/" + item.pictureUrl) : null;

    return (
        <article className="news-item">
            {imgSrc && (
                <div className="news-img-wrap">
                    <img className="news-img" src={imgSrc} alt={item.name} />
                </div>
            )}
            <div className="news-body">
                {item.category && <div className="news-category">{item.category.toUpperCase()}</div>}
                <h3 className="news-title">{item.title}</h3>
                {(item.dateFrom || item.dateTo) && (
                    <div className="news-date">{item.dateFrom}{item.dateTo ? ` - ${item.dateTo}` : ''}</div>
                )}
                {item.text && <p className="news-excerpt">{item.text}</p>}
                {/*<div className="news-more"><a href={item.link || '#'}>więcej</a></div>*/}
            </div>
        </article>
    );
}

function News() {
    const [newsItems, setNewsItems] = useState([]);

    useEffect(() => {
        const apiEndpoint = `${process.env.REACT_APP_API_BASE_URL}/news`;

        axios.get(apiEndpoint)
            .then(response => setNewsItems(response.data))
            .catch(error => console.error('Error fetching act items:', error));
    }, []);

    return (
        <div id="news" className="container-xxl py-5 section">
            <div className="container">
                <h2 className="text-secondary text-uppercase">Aktualności</h2>
                <div className="news-grid">
                    {newsItems.map((item, index) => (
                        <React.Fragment key={index}>
                            <New item={item} />
                            {index < newsItems.length - 1 && <hr className="news-separator" />}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </div>
    );
}
export default News;


